import { WALLETS } from 'data/supportedWallet';
import { WITHDRAW_ADDRESS } from 'data/constant';

interface Network {
	name: string;
	image: string;
	value: string;
}

export interface TotalTvl {
	month: string;
	Value: number;
}

export interface Exchanger {
	name: string;
	image: string;
	value: string;
	estApy: string;
	totalUSDC: number | string;
	totalTvl: TotalTvl[];
	network?: Network[];
	aptosContractAddress?: string;
	tvl?: string;
	depositContractAddress: string;
	withdrawContractAddress: string;
	depositDisabled?: boolean;
	contractAddress?: string;
}

export interface Vault {
	id: number;
	name: string;
	estApy: string;
	currency: string;
	type: string;
	shortDescription: string;
	logo: string;
	darkLogo: string;
	exchanger: Exchanger[];
	token: {
		name: string;
		icon: string;
		alt: string;
		address: string;
		decimalValue: number;
		maxAllowed: number;
		minAllowed: number;
		isNative: boolean;
	}[];
	isActive: boolean;
	wallets: WALLETS[];
}

export const VAULTS: { [keys: string]: Vault[] } = {
	/*Arbitrum: [
		{
			id: 0,
			name: 'Cathena',
			currency: '$',
			type: 'Earn Max points with high capital efficiency',
			shortDescription: 'Delta Neutral Vault Strategy',
			logo: '/images/atlas-brand.png',
			darkLogo: '/images/Atlas-white.png',
			estApy: '28%',
			exchanger: [
				{
					name: 'Arbitrum',
					value: 'arbitrum',
					image: '/images/exchange/bsx.png',
					estApy: '28%',
					totalUSDC: '',
					tvl: '400k',
					depositDisabled: false,
					depositContractAddress:
						'0xdfA98a6B14e984f0e0Dd29a8EBCfd4Deda1313Ea',
					withdrawContractAddress:
						'0x48e9694b509266001cb8728fdcef03ed2e91cfa7',
					totalTvl: [
						{ month: 'Dec', Value: 0.1 },
						{ month: 'Jan', Value: 0.4 },
						{ month: 'Feb', Value: 1 },
						{ month: 'Mar', Value: 10 },
						{ month: 'Apr', Value: 30 },
						{ month: 'May', Value: 50 },
						{ month: 'June', Value: 82 },
						{ month: 'July', Value: 110 },
						{ month: 'Aug', Value: 1400 },
					],
					network: [
						{
							name: 'Arbitrum',
							value: 'Arbitrum',
							image: '/crypto/Arbitrum.svg',
						},
					],
				},
			],
			token: [
				{
					address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
					decimalValue: 6,
					maxAllowed: 100000,
					minAllowed: 0, //1000, //5000,
					name: 'USDC',
					icon: '/images/crypto/usdc.png',
					alt: 'USDC',
					isNative: false,
				},
			],
			isActive: true,
			wallets: [WALLETS.metamask, WALLETS.rabby],
		},
	],*/
	HypeEvm: [
		{
			id: 1,
			name: 'Cathena',
			currency: 'HYPE',
			type: 'Earn Max points with high capital efficiency',
			shortDescription: 'Delta Neutral Vault Strategy',
			logo: '/images/atlas-brand.png',
			darkLogo: '/images/Atlas-white.png',
			estApy: '28%',
			exchanger: [
				{
					name: 'HypeEvm',
					value: 'hypeEvm',
					image: '/images/exchange/hyper.png',
					estApy: '28%',
					totalUSDC: '',
					tvl: '400k',
					depositDisabled: false,
					depositContractAddress:
						'0x3f72bd7023cF8AF1c23faC29219d27bF41B585d5',
					withdrawContractAddress: WITHDRAW_ADDRESS,
					totalTvl: [
						{ month: 'Dec', Value: 0.1 },
						{ month: 'Jan', Value: 0.4 },
						{ month: 'Feb', Value: 1 },
						{ month: 'Mar', Value: 10 },
						{ month: 'Apr', Value: 30 },
						{ month: 'May', Value: 50 },
						{ month: 'June', Value: 82 },
						{ month: 'July', Value: 110 },
						{ month: 'Aug', Value: 1400 },
					],
					network: [
						{
							name: 'HypeEvm',
							value: 'HypeEvm',
							image: '/images/exchange/hyper.png',
						},
					],
				},
			],
			token: [
				{
					address: '0x5555555555555555555555555555555555555555',
					decimalValue: 18,
					maxAllowed: 100000,
					minAllowed: 25, //1000, //5000,
					name: 'HYPE',
					icon: '/images/hyper.png',
					alt: 'HYPE',
					isNative: true,
				},
			],
			isActive: true,
			wallets: [
				WALLETS.metamask,
				WALLETS.rabby,
				WALLETS.rabbyMobile,
				WALLETS.metamaskMobile,
			],
		},
	],
};
